import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { PdfPdftModule } from '../pdf-pdft/pdf-pdft.module';
import { PdfViewModule } from '../pdf/pdf-view.module';
import { SharedModule } from '../shared/shared.module';

import {
  DetailDocumentViewComponent,
  DocumentTitleComponent,
  DocumentToolbarComponent,
  DocumentToolbarMobileComponent,
  DocumentToolbarRegularComponent,
  DocumentViewComponent,
} from './components';
import { DocumentChangesPageComponent } from './document-changes/document-changes-page.component';
import { DocumentCopyPageComponent } from './document-copy/document-copy-page.component';
import { DocumentEditPageComponent } from './document-edit/document-edit-page.component';
import { DocumentHistoryPageComponent } from './document-history/document-history-page.component';
import { DocumentHistoryDetailPageComponent } from './document-history-detail/document-history-detail-page.component';
import { DocumentInfoPageComponent } from './document-info/document-info-page.component';
import { CustomNavigationPageComponent } from './custom-navigation/custom-navigation-page.component';
import { DocumentNavigationPageComponent } from './document-navigation/document-navigation-page.component';
import { DocumentViewPageComponent } from './document-view/document-view-page.component';
import { BasicNavigationPageComponent } from './basic-navigation/basic-navigation-page.component';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { RoesbergModule } from '@ldw/roesberg';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DocumentLeaveDialogComponent } from './components/document-leave-dialog/document-leave-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    BasicNavigationPageComponent,
    CustomNavigationPageComponent,
    DocumentNavigationPageComponent,
    DetailDocumentViewComponent,
    DocumentTitleComponent,
    DocumentToolbarComponent,
    DocumentToolbarMobileComponent,
    DocumentToolbarRegularComponent,
    DocumentViewComponent,
    DocumentChangesPageComponent,
    DocumentCopyPageComponent,
    DocumentEditPageComponent,
    DocumentHistoryPageComponent,
    DocumentHistoryDetailPageComponent,
    DocumentInfoPageComponent,
    DocumentNavigationPageComponent,
    DocumentViewPageComponent,
    DocumentLeaveDialogComponent,
  ],
  exports: [
    BasicNavigationPageComponent,
    CustomNavigationPageComponent,
    DocumentNavigationPageComponent,
    DocumentChangesPageComponent,
    DocumentCopyPageComponent,
    DocumentEditPageComponent,
    DocumentHistoryPageComponent,
    DocumentHistoryDetailPageComponent,
    DocumentInfoPageComponent,
    DocumentNavigationPageComponent,
    DocumentViewPageComponent,
    DetailDocumentViewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PdfViewModule,
    PdfPdftModule,
    MatToolbarModule,
    MatIconModule,
    TranslateModule,
    MatTooltipModule,
    MatMenuModule,
    MatListModule,
    MatButtonModule,
    MatTableModule,
    RouterModule,
    MatCardModule,
    RoesbergModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDialogModule,
  ],
})
export class DocumentsModule {}
